import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Spinner, Table, Row, Col, Card } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import RegistOrLogin from './RegistOrLogin';
import DynamicDialog from './DynamicDialog';
import UserMark from './UserMark';
import PlanConfirmDialog from './common/PlanConfirmDialog';
import MuiButton from '@mui/material/Button';
import { LoginInfo } from '../App';
import { Chip } from '@mui/material';

const Legal = () => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function checkout(plan){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/subscribe/"+plan).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getOfficialPlan(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/official/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [checkoutProcess,setCheckoutProcess] = useState(false)
    const [showDialog,setShowDialog] = useState(false)
    const [title,setTitle] = useState("")
    const [message,setMessage] = useState("")
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // サブスク契約情報
    const [officialPlan, setOfficialPlan] = useState([])

    function dialog(title,message){
        setTitle(title)
        setMessage(message)
        setShowDialog(true)
    }

	useEffect(() => {
		document.querySelector("title").textContent = "料金プラン - ourt AI"
	},[location.pathname])

    useEffect(() => {
        getOfficialPlan().then(r => {
            if(r.result){
                setOfficialPlan(r.data)
            } else {
                setOfficialPlan([])
            }
        })
    },[])

    function checkoutProcessHandler(plan){
        setCheckoutProcess(true)
        isLoggin().then(r => {
            if(r.result){
                checkout(plan).then(r => {
                    if(r.result){
                        window.location.href = r.data.url
                    } else {
                        dialog("",r.errors)
                        setCheckoutProcess(false)
                    }
                })
            } else {
                dialog(t("common.loginToContinue"),<RegistOrLogin />)
                setCheckoutProcess(false)
            }
        })
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Dialog show={showDialog} title="" message={message} handleClose={() => setShowDialog(false)} />
        <Container>
            {/* ヘッダーセクション */}
            <div className="text-center mb-5 py-5" style={{
                background: "#f8f9ff",
                borderRadius: "15px",
                color: "#2d3748",
                boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                border: "1px solid #e2e8f0"
            }}>
                <h1 className="mb-3" style={{fontSize:"32px", fontWeight:"600", color:"#2d3748"}}>
                    料金プラン/運営への支援
                </h1>
                <p className="lead" style={{fontSize:"18px", color:"#64748b", fontWeight:"400"}}>
                    いつもご利用ありがとうございます。<br />
                    みなさんの支援によって、サービスを維持することができています。
                </p>
            </div>

            {/* プレミアムプランセクション */}
            <Row className="mb-5 justify-content-center">
                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-0" style={{
                        borderRadius:"12px", 
                        boxShadow:"0 4px 20px rgba(0,0,0,0.08)",
                        transition:"all 0.3s ease",
                        background:"#ffffff",
                        border:"1px solid #e2e8f0"
                    }}>
                        <Card.Body className="d-flex flex-column p-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold" style={{color:"#2d3748", fontSize:"20px"}}>Standard スタンダード</h4>
                                <UserMark plan="certification" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4 p-3" style={{
                                background:"#6366f1",
                                borderRadius:"10px",
                                color:"white"
                            }}>
                                <div className="h2 fw-bold">$10</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                                <div className="h3 fw-bold mt-2">1,400円</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2 border-0" 
                                    style={{
                                        background:"#6366f1",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"white",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("standard_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($10)
                                </Button>
                                <Button 
                                    className="w-100 border-0" 
                                    style={{
                                        background:"transparent",
                                        border:"1px solid #6366f1",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"#6366f1",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("standard_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (1,400円)
                                </Button>
                            </div>
                            {(loginInfo.plan != "" && loginInfo.plan_payment_method === "Coin") || loginInfo.plan == "" && (
                            <PlanConfirmDialog data={{
                                "item_id":"8db00aac-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "certification" ? officialPlan.subscription_id : "",
                                "name":"スタンダード",
                                "user_name":"アワートAI公式",
                                "amount":1400,
                                "status": loginInfo.plan === "certification" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            )}
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-3" style={{color:"#2d3748"}}>以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-3 mb-2 fw-bold" style={{color:"#6366f1", fontSize:"14px"}}>画像生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 画像生成回数を拡張</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-0 position-relative" style={{
                        borderRadius:"12px", 
                        boxShadow:"0 6px 25px rgba(255, 193, 7, 0.12)",
                        transition:"all 0.3s ease",
                        background:"#ffffff",
                        border:"2px solid #ffc107",
                        transform:"scale(1.02)"
                    }}>
                        <div className="position-absolute top-0 start-50 translate-middle">
                            <Chip 
                                label="オススメ" 
                                style={{
                                    background:"#ffc107",
                                    color:"#2d3748",
                                    fontWeight:"600",
                                    fontSize:"12px"
                                }}
                            />
                        </div>
                        <Card.Body className="d-flex flex-column pt-5 p-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold" style={{color:"#2d3748", fontSize:"20px"}}>Premium プレミアム</h4>
                                <UserMark plan="unlimited" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4 p-3" style={{
                                background:"#8b5cf6",
                                borderRadius:"10px",
                                color:"white"
                            }}>
                                <div className="h2 fw-bold">$30</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                                <div className="h3 fw-bold mt-2">4,000円</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2 border-0" 
                                    style={{
                                        background:"#8b5cf6",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"white",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("premium_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($30)
                                </Button>
                                <Button 
                                    className="w-100 border-0" 
                                    style={{
                                        background:"transparent",
                                        border:"1px solid #8b5cf6",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"#8b5cf6",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("premium_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (4,000円)
                                </Button>
                            </div>
                            {(loginInfo.plan != "" && loginInfo.plan_payment_method === "Coin") || loginInfo.plan == "" && (
                            <PlanConfirmDialog data={{
                                "item_id":"9042b934-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "unlimited" ? officialPlan.subscription_id : "",
                                "name":"プレミアム",
                                "user_name":"アワートAI公式",
                                "amount":4000,
                                "status": loginInfo.plan === "unlimited" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            )}
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-3" style={{color:"#2d3748"}}>以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-3 mb-2 fw-bold" style={{color:"#8b5cf6", fontSize:"14px"}}>画像生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> さらに多くの画像生成が可能</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 高品質モデルの利用</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-0" style={{
                        borderRadius:"12px", 
                        boxShadow:"0 4px 20px rgba(0,0,0,0.08)",
                        transition:"all 0.3s ease",
                        background:"#ffffff",
                        border:"1px solid #e2e8f0"
                    }}>
                        <Card.Body className="d-flex flex-column p-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold" style={{color:"#2d3748", fontSize:"20px"}}>Premium + プレミアムプラス</h4>
                                <UserMark plan="plus" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4 p-3" style={{
                                background:"#a855f7",
                                borderRadius:"10px",
                                color:"white"
                            }}>
                                <div className="h2 fw-bold">$140</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                                <div className="h3 fw-bold mt-2">20,000円</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2 border-0" 
                                    style={{
                                        background:"#a855f7",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"white",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("plus_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($140)
                                </Button>
                                <Button 
                                    className="w-100 border-0" 
                                    style={{
                                        background:"transparent",
                                        border:"1px solid #a855f7",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"#a855f7",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("plus_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (20,000円)
                                </Button>
                            </div>
                            {(loginInfo.plan != "" && loginInfo.plan_payment_method === "Coin") || loginInfo.plan == "" && (
                            <PlanConfirmDialog data={{
                                "item_id":"9042b951-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "plus" ? officialPlan.subscription_id : "",
                                "name":"プレミアムプラス",
                                "user_name":"アワートAI公式",
                                "amount":20000,
                                "status": loginInfo.plan === "plus" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            )}
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-3" style={{color:"#2d3748"}}>以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-3 mb-2 fw-bold" style={{color:"#a855f7", fontSize:"14px"}}>画像生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 大幅に拡張された画像生成機能</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> プレミアム高品質モデルの利用</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* エコノミープランセクション */}
            <Row className="mb-5 justify-content-center">
                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-0" style={{
                        borderRadius:"12px", 
                        boxShadow:"0 4px 20px rgba(0,0,0,0.08)",
                        transition:"all 0.3s ease",
                        background:"#ffffff",
                        border:"1px solid #e2e8f0"
                    }}>
                        <Card.Body className="d-flex flex-column p-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold" style={{color:"#2d3748", fontSize:"20px"}}>Basic ベーシック</h4>
                                <UserMark plan="basic" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4 p-3" style={{
                                background:"#94a3b8",
                                borderRadius:"10px",
                                color:"white"
                            }}>
                                <div className="h2 fw-bold">$4</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                                <div className="h3 fw-bold mt-2">500円</div>
                                <small style={{opacity:"0.9"}}>1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2 border-0" 
                                    style={{
                                        background:"#94a3b8",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"white",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("basic_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($4)
                                </Button>
                                <Button 
                                    className="w-100 mb-2 border-0" 
                                    style={{
                                        background:"transparent",
                                        border:"1px solid #94a3b8",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"#94a3b8",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => checkoutProcessHandler("basic_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (500円)
                                </Button>
                                <div className='text-center'>
                                    <MuiButton 
                                        className='w-100' 
                                        disabled
                                        style={{
                                            borderRadius:"8px",
                                            textTransform:"none",
                                            fontWeight:"500"
                                        }}
                                    >
                                        コイン未対応
                                    </MuiButton>
                                </div>
                            </div>
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-3" style={{color:"#2d3748"}}>以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 広告非表示</li>
                                    <li className="mt-3 mb-2 fw-bold" style={{color:"#94a3b8", fontSize:"14px"}}>画像生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> ポイントを消費して生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> slowモードで利用</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-0" style={{
                        borderRadius:"12px", 
                        boxShadow:"0 4px 20px rgba(0,0,0,0.08)",
                        transition:"all 0.3s ease",
                        background:"#ffffff",
                        border:"1px solid #e2e8f0"
                    }}>
                        <Card.Body className="d-flex flex-column p-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold" style={{color:"#2d3748", fontSize:"20px"}}>Free(アカウント登録)</h4>
                            </div>
                            <div className="text-center mb-4 p-3" style={{
                                background:"#10b981",
                                borderRadius:"10px",
                                color:"white"
                            }}>
                                <div className="h2 fw-bold">$0</div>
                                <small style={{opacity:"0.9"}}>永年</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 border-0" 
                                    style={{
                                        background:"#10b981",
                                        borderRadius:"8px",
                                        padding:"10px 0",
                                        fontWeight:"500",
                                        color:"white",
                                        transition:"all 0.3s ease"
                                    }}
                                    onClick={() => navigate("/regist-select")}
                                >
                                    アカウント登録する
                                </Button>
                            </div>
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-3" style={{color:"#2d3748"}}>以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> 青色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-3 mb-2 fw-bold" style={{color:"#10b981", fontSize:"14px"}}>画像生成</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-3" style={{fontSize:"12px"}} /> ポイントを消費して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* プラン詳細へのリンク */}
            <div className="text-center mb-5">
                <Link 
                    to="/plan-details" 
                    className="btn btn-lg"
                    style={{
                        background:"#6366f1",
                        color:"white",
                        border:"none",
                        borderRadius:"10px",
                        padding:"12px 30px",
                        fontSize:"16px",
                        fontWeight:"500",
                        textDecoration:"none",
                        transition:"all 0.3s ease"
                    }}
                >
                    各プランの詳細な内容・生成枚数を確認する
                </Link>
            </div>

            {/* 特定商取引法 */}
            <div>
                <h3 className="mb-4">特定商取引法に基づく表記</h3>
                <Table striped bordered hover className="mb-5">
                    <tbody>
                        <tr><th style={{width:"25%"}}>運営会社</th><td>アワート合同会社</td></tr>
                        <tr><th>代表者</th><td>元水 稜真</td></tr>
                        <tr><th>所在地</th><td>〒101-0024 東京都千代田区神田和泉町1番地6-16ヤマトビル405</td></tr>
                        <tr><th>電話番号</th><td>090-8835-2738 ※サービスについてのお問い合わせはその他の連絡先から行ってください。</td></tr>
                        <tr><th>その他の連絡先</th><td>
                            <div className="d-flex flex-column">
                                <Link to="https://twitter.com/ourt_ai" className="mb-1">X(旧Twitter)</Link>
                                <Link to="https://discord.gg/646h4vFMv2" className="mb-1">Discord</Link>
                                <Link to="https://lin.ee/9JVODFH" className="mb-1">LINE</Link>
                                <span>メール：contact＠ourt-ai.work</span>
                            </div>
                        </td></tr>
                        <tr><th>料金</th><td>消費税込みの価格で個別に記載。</td></tr>
                        <tr><th>代金の支払い方法</th><td>利用する決済サービスに記載の方法で行う。</td></tr>
                        <tr><th>代金の支払時期</th><td>月額課金制とし、決済を行った日に当月分が請求され、以降は解約しない限り自動的に毎月決済されます。</td></tr>
                        <tr><th>提供時期</th><td>決済後、アワートAI内へプランの反映を行った後に利用可能(3日以内)。</td></tr>
                        <tr><th>返品等についての特約に関する事項</th><td>契約成立後の返品、返金、キャンセルはできません。</td></tr>
                    </tbody>
                </Table>
            </div>
        </Container>
        <Footer />
    </div>
    )
}

export default Legal;
